import { EventDetailsEffects } from './details.effects';
import { EventSearchResultsEffects } from './event-searchresults.effect';

export const effects: any[] = [EventDetailsEffects, EventSearchResultsEffects];

export * from './details.effects';
export * from './event-searchresults.effect';

